module.exports = __webpack_public_path__ + "static/media/ilus-services-digital-product.2a61ff3d.svg";